module.exports = __webpack_public_path__ + "img/watermark-bg.7544f530.jpg";